import { SeeqNames } from '@/main/app.constants.seeqnames';
import { BatchActionEnum } from '@/sdk/model/TableDefinitionInputV1';
import { AgGridModules } from '@/core/tableUtilities/tableUtilities.types';
import type { ColDef, SizeColumnsToContentStrategy } from 'ag-grid-community';
import _ from 'lodash';
import { ColumnDefinitionInputV1 } from '@/sdk';
import { ColumnTypeEnum } from '@/sdk/model/ColumnDefinitionOutputV1';
import { COMMON_AG_GRID_MODULES } from '@/core/tableUtilities/agGrid.constants';

export const SCALING_TABLE_FETCH_CANCELLATION_GROUP = 'scaling-table-fetch';
export const SCALING_TABLE_DEFINITION_CANCELLATION_GROUP = 'scaling-table-definition';
export const ITEM_TABLE_FETCH_CANCELLATION_GROUP = 'item-table-fetch';
export const ITEM_TABLE_DEFINITION_CANCELLATION_GROUP = 'item-table-definition';

export const ID_COLUMN: ColumnDefinitionInputV1 = {
  columnName: SeeqNames.MaterializedTables.ItemIdColumn,
  columnType: ColumnTypeEnum.UUID,
  columnRules: [{ eventProperty: { propertyName: 'id' } }],
  sortIndex: 0,
  sortAscending: true,
};

export const DATUM_ID_COLUMN: ColumnDefinitionInputV1 = {
  columnName: SeeqNames.MaterializedTables.DatumIdColumn,
  columnType: ColumnTypeEnum.TEXT,
  columnRules: [{ eventProperty: { propertyName: '' } }],
};

export const DEFAULT_COLUMN_DEFINITION_INPUTS = [ID_COLUMN, DATUM_ID_COLUMN];

export const DEFAULT_PROPERTIES_FOR_ALL_ITEM_COLUMNS: string[] = [
  SeeqNames.Properties.DatasourceClass,
  SeeqNames.Properties.Name,
  SeeqNames.Properties.Type,
  SeeqNames.Properties.ValueUom,
];

export const batchActionOptions = [
  {
    value: BatchActionEnum.UPDATEEXISTINGINSERTNEWCLEANUP,
    label: 'SCALING.BATCH_ACTION.OPTIONS.UPDATE_EXISTING_INSERT_NEW_CLEANUP',
  },
  { value: BatchActionEnum.UPDATEEXISTINGINSERTNEW, label: 'SCALING.BATCH_ACTION.OPTIONS.UPDATE_EXISTING_INSERT_NEW' },
  { value: BatchActionEnum.ONLYUPDATEEXISTING, label: 'SCALING.BATCH_ACTION.OPTIONS.ONLY_UPDATE_EXISTING' },
  { value: BatchActionEnum.ONLYINSERTNEW, label: 'SCALING.BATCH_ACTION.OPTIONS.ONLY_INSERT_NEW' },
];

export const MAX_ROW_COUNT = 500000;

export const MODULES = _.concat(COMMON_AG_GRID_MODULES, [
  AgGridModules.ColumnMenuModule,
  AgGridModules.ContextMenuModule,
  AgGridModules.ClipboardModule,
  AgGridModules.CellSelectionModule,
  AgGridModules.ColumnsToolPanelModule,
  AgGridModules.RowGroupingModule,
  AgGridModules.RowDragModule,
  AgGridModules.ColumnApiModule,
  AgGridModules.EventApiModule,
  AgGridModules.CustomEditorModule,
  AgGridModules.TextEditorModule,
  AgGridModules.ClientSideRowModelApiModule,
  AgGridModules.RowGroupingPanelModule,
]);

export const GARBAGE_OBJECT_CHAR = '὇B';

export const DEFAULT_COL_DEF: ColDef = {
  menuTabs: ['generalMenuTab'],
  suppressHeaderMenuButton: false,
  headerComponentParams: { menuIcon: 'fa-bars' },
};

export const DEFAULT_AUTO_GROUP_COL_DEF: ColDef = {
  minWidth: 200,
};

export const AUTO_SIZE_STRATEGY: SizeColumnsToContentStrategy = {
  type: 'fitCellContents',
};
